import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ProductSelectorComponent } from './product-selector.component';

@NgModule({
  declarations: [
    ProductSelectorComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    ProductSelectorComponent
  ],
  providers: []
})
export class ProductSelectorModule {}


